<template>
	<div class="omapi-card__flex omapi-dash__create">
		<templates-type-card
			v-for="(typeLabel, type) in templateTypes"
			:key="'template-type-' + type"
			class="omapi-dash__create-card"
			size="half"
			:type="type"
			:type-label="typeLabel"
		>
			<core-button :link-style="true" :arrow="true">Create New</core-button>
		</templates-type-card>
	</div>
</template>

<script>
export default {
	computed: {
		templateTypes() {
			return this.$store.getters['templates/typeNames'];
		},
	},
};
</script>
